module.exports = __webpack_public_path__ + "img/slider_d04.7f203f6.b9109800.png";